import { identitePourDocument } from '../features/documents/DocumentA4.jsx';
import { DEVISE, fmt } from './currency';
import { ouvreReglages } from './onglet-reglages';

/**
 * Ce qui manque pour que la pièce parte avec son QR-facture.
 *
 * Sans IBAN, le serveur ne pose pas de QR-facture : le client recevrait une
 * offre qui demande un acompte sans moyen de le verser. L'avertissement le dit
 * avant l'envoi et mène à l'endroit où l'IBAN se saisit.
 *
 * @param {object} p paramètres
 * @param {object} p.soc société émettrice, avec ses profils par secteur
 * @param {object} p.piece offre ou facture affichée
 * @param {number} p.montant montant que porterait le QR-facture (acompte ou total)
 * @param {string} p.quoi « l’acompte » ou « la facture »
 * @param {(cible: string) => void} p.onNav navigation de l'application
 * @param {boolean} [p.refait] vrai si le PDF est refait après l'ajout de l'IBAN
 *   (l'offre) ; une facture émise reste telle qu'elle est partie
 * @returns {{texte: string, action: string, onAction: () => void} | null} l'avertissement, ou rien
 */
export function avertissementIban({ soc, piece, montant, quoi, onNav, refait }) {
  if (!piece || piece.noPay || piece.bonCommande || !(montant > 0)) return null;
  const iban = identitePourDocument(soc, piece)?.iban;
  if (iban && String(iban).trim()) return null;
  return {
    texte:
      'Ton IBAN n’est pas renseigné : le QR-facture de ' +
      quoi +
      ' (' +
      DEVISE +
      ' ' +
      fmt(montant) +
      ') ne figurera pas sur le document envoyé. ' +
      (refait
        ? 'Ajoute-le, puis envoie : le PDF sera refait avec le QR.'
        : 'Ajoute-le avant d’envoyer.'),
    action: '🏦 Ajouter mon IBAN',
    onAction: () => ouvreReglages(onNav, 'banque'),
  };
}
